import { jsx as _jsx } from "react/jsx-runtime";
import * as Ariakit from '@ariakit/react';
import { forwardRef } from 'react';
import * as Styles from './styles';
export const Details = forwardRef(function ExpansionPanelDetails({ children, className, renderWhenCollapsed = false, animate = true, ...rest }, ref) {
    return (_jsx(Ariakit.DisclosureContent, { alwaysVisible: renderWhenCollapsed, render: _jsx(Styles.Details, { ref: ref, className: className, "$animate": animate, ...rest }), children: _jsx(Styles.DetailsContent, { children: children }) }));
});
//# sourceMappingURL=Details.js.map